<template>
  <heatmapComponent />
</template>

<script>
import heatmapComponent from '../partials/heatmap.vue';

export default {
  components: {
    heatmapComponent,
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      // TODO: しきい値を決める
      this.$store.commit('heatmap/initMinMax', {
        min: 5,
        max: 30,
      });
      this.$store.commit('heatmap/setTargetKey', 'congestionDegree');
    },
  },
};
</script>



// WEBPACK FOOTER //
// congestion.vue?0a72fe9c